import './BeAnOwnerFormStepper.scss';
import Step01 from './Step01';
import { useEffect, useState } from 'react';
import Step02 from './Step02';
import { FormProvider, useForm } from 'react-hook-form';
import Step03 from './Step03';
import { UrbainUser } from '../../../../redux/user/user.types';

interface BeAnOwnerFormStepperProps {
  urbainUser: UrbainUser;
  step: number;
  setStep: Function;
  metros: Array<string>;
}

function BeAnOwnerFormStepper({ urbainUser, step, setStep, metros }: BeAnOwnerFormStepperProps) {
  const methods = useForm({
    defaultValues: {
      FirstName: urbainUser?.FirstName,
      LastName: urbainUser?.LastName,
      PhoneNumberCode: urbainUser?.PhoneNumberCode,
      PhoneNumber: urbainUser?.PhoneNumber,
      Email: urbainUser?.Email
    }
  });

  useEffect(() => {
    if (urbainUser) {
      methods.setValue('FirstName', urbainUser?.FirstName);
      methods.setValue('LastName', urbainUser?.LastName);
      methods.setValue('PhoneNumberCode', urbainUser?.PhoneNumberCode);
      methods.setValue('PhoneNumber', urbainUser?.PhoneNumber);
      methods.setValue('Email', urbainUser?.Email);
    }
  }, [urbainUser]);

  return (
    <FormProvider {...methods}>
      {step === 1 && !!metros && <Step01 nextStep={setStep} metros={metros} />}
      {step === 2 && <Step02 nextStep={setStep} />}
      {step === 3 && <Step03 />}
    </FormProvider>
  );
}

export default BeAnOwnerFormStepper;
